import _ from 'lodash';

const getExtensionValueDecimal = (resource, fhirUrl) => {
	return _.find(resource.extension, elem => elem.url === fhirUrl)?.valueDecimal || '';
};

export default getExtensionValueDecimal;
